import { render, staticRenderFns } from "./MainHeaderDescriptive.vue?vue&type=template&id=15a80dee&scoped=true"
import script from "./MainHeaderDescriptive.vue?vue&type=script&lang=js"
export * from "./MainHeaderDescriptive.vue?vue&type=script&lang=js"
import style0 from "./MainHeaderDescriptive.vue?vue&type=style&index=0&id=15a80dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a80dee",
  null
  
)

export default component.exports